// MEALUP section seams (2026-10-24, Iliyan: no dry straight cuts between sections of different colours).
// Every pair of neighbouring sections in <main> with clearly different background colours gets a shaped edge:
// the shape is drawn in the colour of a plain (single-colour) side, over the edge of the other side, so photos,
// ribbons and films keep their own background up to the shape. Style: theme setting "MEALUP: преходи между секции"
// (window.muSeam.style), or ?mu_seam=mix|ribbon|arch|drip|seal|none in the address for a quick look at each.
// "mix" (default, Iliyan 2026-10-24): a soft wave next to the orange ribbon sections, a gentle arch (Ninja Mame) between
// plain colours. Shapes are low (about 1.8% of the width) so narrow sections keep their room.
// Per section: data-mu-seam-top / data-mu-seam-bottom = arch | ribbon | off on the section or its main element (this
// also allows a shape next to a short strip, which otherwise keeps a straight edge). Nothing moves, nothing is focusable.
(function () {
  const cfg = window.muSeam || {};
  let style = cfg.style || 'mix';
  if (style === 'curve') style = 'arch';
  try { const q = new URLSearchParams(location.search).get('mu_seam'); if (q) style = q; } catch (e) {}
  if (style === 'none') return;

  // the edge line inside a 1440 x 60 box (y grows down); the fill is closed above or below it
  const LINES = {
    // the lower side rises as a soft dome (Ninja Mame): low at the sides, high in the middle
    arch: 'M0,60 Q720,-58 1440,60',
    // a long, gentle wave like the ribbons
    ribbon: 'M0,44 C260,14 520,10 760,28 S1180,52 1440,18',
    drip: (() => {
      // melted cheese: a flat edge with rounded drips of different lengths
      const drips = [[90, 26, 34], [260, 18, 20], [470, 30, 46], [690, 22, 26], [880, 34, 52], [1080, 20, 22], [1270, 28, 38]];
      let d = 'M0,10';
      drips.forEach(([x, w, len]) => {
        const r = w / 2;
        d += ` H${x - 10} C${x - 2},10 ${x},14 ${x},${18} V${10 + len - r} A${r},${r} 0 0 0 ${x + w},${10 + len - r} V18 C${x + w},14 ${x + w + 2},10 ${x + w + 10},10`;
      });
      return d + ' H1440';
    })(),
    seal: (() => {
      // the crimped heat seal at the top of the pouch: small even teeth
      let d = 'M0,14';
      for (let x = 0; x < 1440; x += 16) d += ` L${x + 8},30 L${x + 16},14`;
      return d;
    })(),
  };
  if (style !== 'mix' && !LINES[style]) return;
  const kindFor = (patternedSide) => style === 'mix' ? (patternedSide ? 'ribbon' : 'arch') : style;

  // blocks that already melt into their neighbours (the two home films) or float over them (the seal row, the sticky bar)
  const NOPE = '.mu-hfilm, .mu-hdrop, .mu-sbuy, [data-mu-seam="off"]';
  const GHOST = '.mu-badge-marquee--overlay, .mu-sbuy';
  const PATTERNED = '.mu-ribbon, .mu-band, .mu-section--orange';
  const MIN_H = 160; // short strips (trust rows, badge rows) keep their straight edges

  function rgb(str) {
    const m = (str || '').match(/rgba?\(([^)]+)\)/);
    if (!m) return null;
    const p = m[1].split(/[ ,/]+/).filter(Boolean).map(Number);
    if (p.length > 3 && p[3] < 0.95) return null;
    return p.slice(0, 3);
  }
  const hasBg = (el) => { const cs = getComputedStyle(el); return !!rgb(cs.backgroundColor) || cs.backgroundImage !== 'none'; };
  function patterned(el) {
    const cs = getComputedStyle(el);
    if (cs.backgroundImage !== 'none' || el.matches(PATTERNED)) return true;
    const pb = getComputedStyle(el, '::before');
    const mask = pb.maskImage || pb.webkitMaskImage || 'none';
    return pb.content !== 'none' && (mask !== 'none' || pb.backgroundImage !== 'none');
  }
  const wide = (el) => el.getBoundingClientRect().width >= window.innerWidth * 0.9;
  // the colour bands of a section: the element that paints the whole section, or (for a section of several
  // blocks with their own backgrounds, like the product page's app blocks) each full-width painted block
  function bandsOf(sec) {
    const H = sec.getBoundingClientRect().height;
    let p = null;
    const find = (el, d) => {
      if (p || d > 5) return;
      const r = el.getBoundingClientRect();
      if (r.height >= H * 0.8 && wide(el) && hasBg(el)) { p = el; return; }
      [...el.children].forEach((c) => find(c, d + 1));
    };
    find(sec, 0);
    if (p) return [p];
    const out = [];
    const walk = (el, d) => {
      if (d > 6) return;
      [...el.children].forEach((c) => {
        if (c.classList.contains('mu-seam')) return;
        const r = c.getBoundingClientRect();
        if (r.height > 60 && wide(c) && hasBg(c)) out.push(c); else walk(c, d + 1);
      });
    };
    walk(sec, 0);
    return out;
  }
  const dist = (a, b) => Math.abs(a[0] - b[0]) + Math.abs(a[1] - b[1]) + Math.abs(a[2] - b[2]);

  function shape(fill, below, kind) {
    const close = below ? ' L1440,60 L0,60 Z' : ' L1440,0 L0,0 Z';
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 1440 60');
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.classList.add('mu-seam', below ? 'mu-seam--bottom' : 'mu-seam--top');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', LINES[kind] + close);
    path.setAttribute('fill', `rgb(${fill.join(',')})`);
    svg.appendChild(path);
    return svg;
  }
  // the shape never covers text or buttons: if the content comes closer to the edge than the shape, the host gets
  // the missing room as padding on that side (every run starts from the original padding, so it never adds up).
  // Reads and writes are kept apart (all reads, then all writes), so a run lays the page out once instead of once per seam.
  const PAD = { top: ['paddingTop', 'muPadT'], bottom: ['paddingBottom', 'muPadB'] };
  function roomNeeded(host, side, seam) {
    const hr = host.getBoundingClientRect(), need = seam.getBoundingClientRect().height + 10;
    let edge = side === 'top' ? Infinity : -Infinity;
    host.querySelectorAll('h1, h2, h3, p, a, button, img, li, label, input').forEach((el) => {
      // screen-reader-only text (.visually-hidden) is not on screen: its list items overflow the 1 px box downwards and
      // once gave the pyramid chapter of the science page about 390 px of empty room on desktop
      if (el.closest('.mu-seam, .visually-hidden') || !el.offsetParent) return;
      const pos = getComputedStyle(el).position;
      if (pos === 'absolute' || pos === 'fixed') return;
      const r = el.getBoundingClientRect();
      if (!r.height) return;
      edge = side === 'top' ? Math.min(edge, r.top) : Math.max(edge, r.bottom);
    });
    if (!isFinite(edge)) return 0;
    const gap = side === 'top' ? edge - hr.top : hr.bottom - edge;
    return gap < need ? (parseFloat(getComputedStyle(host)[PAD[side][0]]) || 0) + (need - gap) : 0;
  }

  const sections = () => [...document.querySelectorAll('main > .shopify-section, #MainContent > .shopify-section')];
  let heights = '';
  const measure = () => sections().map((s) => s.offsetHeight).join(',');

  function run() {
    document.querySelectorAll('.mu-seam').forEach((s) => s.remove());
    document.querySelectorAll('[data-mu-pad-t], [data-mu-pad-b]').forEach((el) => {
      if (el.dataset.muPadT !== undefined) el.style.paddingTop = el.dataset.muPadT;
      if (el.dataset.muPadB !== undefined) el.style.paddingBottom = el.dataset.muPadB;
    });
    const secs = sections()
      .filter((s) => s.offsetHeight > 0 && getComputedStyle(s).display !== 'none' && !(s.firstElementChild && s.firstElementChild.matches(GHOST)));
    const bands = [];
    secs.forEach((s) => {
      const off = s.matches(NOPE) || !!(s.firstElementChild && s.firstElementChild.matches(NOPE));
      const tag = (el, k) => el.getAttribute(k) || s.getAttribute(k) || (s.firstElementChild && s.firstElementChild.getAttribute(k)) || '';
      bandsOf(s).forEach((el) => bands.push({ el, off, top: tag(el, 'data-mu-seam-top'), bottom: tag(el, 'data-mu-seam-bottom') }));
    });
    // 1. decide every seam (reads only)
    const plan = [];
    for (let i = 0; i < bands.length - 1; i++) {
      const A = bands[i], B = bands[i + 1];
      const forced = B.top || A.bottom;
      if (forced === 'off' || ((A.off || B.off) && !forced)) continue;
      const ra = A.el.getBoundingClientRect(), rb = B.el.getBoundingClientRect();
      if (Math.abs(rb.top - ra.bottom) > 3) continue;
      if (!forced && (ra.height < MIN_H || rb.height < MIN_H)) continue;
      const ca = rgb(getComputedStyle(A.el).backgroundColor), cb = rgb(getComputedStyle(B.el).backgroundColor);
      if (!ca || !cb || dist(ca, cb) < 30) continue;
      const pa = !patterned(A.el), pb = !patterned(B.el);
      const kind = forced && LINES[forced] ? forced : kindFor(!pa || !pb);
      // draw the plain side's colour over the other side's edge; a short strip is never the host (its text would be covered)
      const aHost = pb && (ra.height >= MIN_H || !pa), bHost = pa && (rb.height >= MIN_H || !pb);
      if (pb && (aHost || !bHost)) plan.push({ host: A.el, side: 'bottom', fill: cb, kind });
      else if (pa) plan.push({ host: B.el, side: 'top', fill: ca, kind });
    }
    // 2. draw them (writes only)
    plan.forEach((p) => {
      p.host.classList.add('mu-seam-host');
      p.svg = shape(p.fill, p.side === 'bottom', p.kind);
      if (p.side === 'bottom') p.host.appendChild(p.svg); else p.host.insertBefore(p.svg, p.host.firstChild);
      const [prop, key] = PAD[p.side];
      if (p.host.dataset[key] === undefined) p.host.dataset[key] = p.host.style[prop] || '';
    });
    // 3. measure the room every host needs (reads), 4. give it (writes)
    plan.forEach((p) => { p.room = roomNeeded(p.host, p.side, p.svg); });
    plan.forEach((p) => { if (p.room) p.host.style[PAD[p.side][0]] = p.room + 'px'; });
    heights = measure();
  }
  // content that arrives late (the review widget, app blocks) can change a section's height after load, and a pair
  // measured before that kept or lost its seam by chance (the reviews/recipes seam on the product page came and went
  // between visits). While the page is still settling (until 20 s after load) the seams are drawn again once the
  // heights stop changing; later changes made by the visitor (tabs, accordions) are left alone, as before. The room the
  // seams add themselves is in the recorded heights, so this never loops.
  if ('ResizeObserver' in window) {
    let t = 0;
    const ro = new ResizeObserver(() => { clearTimeout(t); t = setTimeout(() => { if (measure() !== heights) run(); }, 300); });
    const watch = () => sections().forEach((s) => ro.observe(s));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
    const stop = () => setTimeout(() => { ro.disconnect(); clearTimeout(t); }, 20000);
    if (document.readyState === 'complete') stop(); else window.addEventListener('load', stop);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:unload', () => setTimeout(run, 50));
  document.documentElement.setAttribute('data-mu-seam', style);
})();
